import clsx from 'clsx';
import React, { forwardRef, useEffect, useState } from 'react';

type LoadingIndicatorProps = {
	delay?: number; // delay before showing, in seconds
	duration?: number; // animation "speed", in seconds
	className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export const LoadingIndicator = forwardRef<HTMLDivElement, LoadingIndicatorProps>(({
	delay = 0,
	duration = 1.25,
	className,
	...props
}, ref) => {
	const [show, setShow] = useState(delay === 0);

	useEffect(() => {
		if (delay) {
			const timeout = setTimeout(() => setShow(true), delay * 1000);
			return () => clearTimeout(timeout);
		}
		return () => {};
	}, [delay, setShow]);

	return (
		<div ref={ref} className={clsx('flex justify-center items-center py-12 transition-opacity duration-500', show ? 'opacity-100' : 'opacity-0', className)} {...props}>
			<div className="inline-flex space-x-1.5">
				<div className="w-2 h-2 rounded-full animate-loading-bounce-1" style={{ animationDuration: `${duration}s` }} />
				<div className="w-2 h-2 rounded-full animate-loading-bounce-2" style={{ animationDuration: `${duration}s` }} />
				<div className="w-2 h-2 rounded-full animate-loading-bounce-3" style={{ animationDuration: `${duration}s` }} />
			</div>
		</div>
	);
});

LoadingIndicator.displayName = 'LoadingIndicator';
